<template>
  <TechList></TechList>
</template>

<script>

import TechList from "@/components/User/TechList";

export default {
  name: "HomeTechs",
  components: {
    TechList,
  },
  data() {
    return {
      detail: {
        id: null,
        firstname: null,
        lastname: null
      },
    };
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/User/HomeTechs.vue